import { Route, Routes } from 'react-router-dom';
import RequireAuth from '../components/require-auth/require-auth.component';
import { AccountTypes } from '../enums/account-type';
import { MerchantOnboardingStatus } from '../enums/merchant-onboarding-status';
import { Roles } from '../enums/roles-enum';
import ActivatePage from '../pages/onboarding-pages/activate.page';
import MerchantUpdateOnboardingPage from '../pages/onboarding-pages/merchant-update-onboarding.page';
import OnboardingDeclinedPage from '../pages/onboarding-pages/onboarding-declined.page';
import OnboardingPendingPage from '../pages/onboarding-pages/onboarding-pending-approval.page';

const allowedRoles = [
  Roles.MERCHANT,
  Roles.PARTNER,
  Roles.RESELLER,
  Roles.MERCHANT_BRANCH
];

function MerchantOnboardingRoutes() {
  return (
    <Routes>
      <Route
        element={
          <RequireAuth
            allowedRoles={allowedRoles}
            allowedAccountType={[
              AccountTypes.MERCHANT_BRANCH,
              AccountTypes.PARTNER,
              AccountTypes.RESELLER,
              AccountTypes.MERCHANT
            ]}
            allowedOnboardingStatus={[
              MerchantOnboardingStatus.NO_RECORD,
              MerchantOnboardingStatus.DECLINED
            ]}
          />
        }
      >
        <Route path="activate">
          {/* Route to activation form */}
          <Route
            element={
              <RequireAuth
                allowedRoles={allowedRoles}
                allowedAccountType={[
                  AccountTypes.MERCHANT_BRANCH,
                  AccountTypes.PARTNER,
                  AccountTypes.RESELLER,
                  AccountTypes.MERCHANT
                ]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.NO_RECORD]}
              />
            }
          >
            <Route index element={<ActivatePage />} />
          </Route>
          {/* Route to declined merchant updating onboarding details */}
          <Route
            element={
              <RequireAuth
                allowedRoles={allowedRoles}
                allowedAccountType={[
                  AccountTypes.MERCHANT_BRANCH,
                  AccountTypes.PARTNER,
                  AccountTypes.RESELLER,
                  AccountTypes.MERCHANT
                ]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.DECLINED]}
              />
            }
          >
            <Route
              path=":onboardingReferenceNumber"
              element={<MerchantUpdateOnboardingPage />}
            />
          </Route>
        </Route>
      </Route>
      {/* Route to pending  */}
      <Route
        element={
          <RequireAuth
            allowedRoles={allowedRoles}
            allowedAccountType={[
              AccountTypes.MERCHANT_BRANCH,
              AccountTypes.PARTNER,
              AccountTypes.RESELLER,
              AccountTypes.MERCHANT
            ]}
            allowedOnboardingStatus={[
              MerchantOnboardingStatus.NEW,
              MerchantOnboardingStatus.PENDING
            ]}
          />
        }
      >
        <Route path="pending" element={<OnboardingPendingPage />} />
      </Route>
      {/* Route to declined */}
      <Route
        element={
          <RequireAuth
            allowedRoles={allowedRoles}
            allowedAccountType={[
              AccountTypes.MERCHANT_BRANCH,
              AccountTypes.PARTNER,
              AccountTypes.RESELLER,
              AccountTypes.MERCHANT
            ]}
            allowedOnboardingStatus={[MerchantOnboardingStatus.DECLINED]}
          />
        }
      >
        <Route path="declined" element={<OnboardingDeclinedPage />} />
      </Route>
    </Routes>
  );
}

export default MerchantOnboardingRoutes;
